<template>
  <div class="PhotovoltaicStationCharts">
    <div class="timeHead">
      <el-select
        v-model="timeType"
        placeholder="请选择"
        :popper-append-to-body="false"
        size="small"
        style="width: 10%; margin: 0 20px 0 20px"
        @change="getDataValue"
      >
        <el-option label="日" value="DAY"> </el-option>
        <el-option label="月" value="MONTH"> </el-option>
        <el-option label="年" value="YEAR"> </el-option>
        <el-option label="全部" value="UNLIMITED"> </el-option>
      </el-select>
      <template v-if="timeType !== 'UNLIMITED'">
        <el-date-picker
          size="small"
          style="margin-right: 20px"
          v-model="timeValue"
          :clearable="false"
          :type="
            timeType == 'YEAR' ? 'year' : timeType == 'MONTH' ? 'month' : 'date'
          "
          :key="
            timeType == 'YEAR' ? 'year' : timeType == 'MONTH' ? 'month' : 'date'
          "
          :value-format="
            timeType == 'YEAR'
              ? 'yyyy'
              : timeType == 'MONTH'
              ? 'yyyy-MM'
              : 'yyyy-MM-dd'
          "
        >
        </el-date-picker>
      </template>
      <el-button type="primary" size="small" @click="submit">查询</el-button>
      <el-button
        type="primary"
        size="small"
        plain
        @click="exportExcel"
        v-if="judgeAuthority('zixitong:guangfu:photovoltaicStation:export')"
        ><i class="el-icon-download el-icon--left"></i>EXCEL</el-button
      >
    </div>
    <div class="chartsWrap">
      <OmitLine :id="'photovoltaicStationCharts'" :chartsData="chartsData" />
    </div>
  </div>
</template>

<script>
import { judgeAuthority } from "@/assets/js/utils";
import { dateFtt } from "@/assets/js/utils";
import api from "@/api";
import OmitLine from "@/components/EChartsFolder/OmitLine";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
export default {
  props: {
    entity: {
      type: Object,
      default() {
        return { id: "", type: "", name: "" };
      },
    },
  },
  components: {
    OmitLine,
  },
  data() {
    return {
      timeType: "DAY",
      timeValue: null,
      chartsData: {
        name: "发电量",
        unit: "kw·h",
        xData: [],
        yData: [],
      },
      format: "",
      period: "",
      activeTimeValue: "",
      isCreated: true,
    };
  },
  methods: {
    judgeAuthority,
    getDataValue() {
      if (this.timeType == "YEAR") {
        this.timeValue = dateFtt("yyyy", new Date());
        this.format = "YYYY-MM";
        this.period = "month";
      } else if (this.timeType == "MONTH") {
        this.timeValue = dateFtt("yyyy-MM", new Date());
        this.format = "MM-DD";
        this.period = "day";
      } else if (this.timeType == "DAY") {
        this.timeValue = dateFtt("yyyy-MM-dd", new Date());
        this.format = "HH:mm";
        this.period = "hour";
      } else {
        this.timeValue = null;
        this.format = "YYYY";
        this.period = "year";
      }
    },
    async submit() {
      if (!this.timeValue && this.timeType !== "UNLIMITED") {
        this.$message.warning("请选择时间!");
        return;
      }
      let data = {
        startTime: "",
        endTime: "",
        needPeriodEc: false,
        isPower: false,
        period: this.period,
      };
      if (this.entity.type === "project") {
        data.projectId = this.entity.id;
      } else if (this.entity.type === "station") {
        data.stationId = this.entity.id;
      } else if (this.entity.type === "inverter") {
        data.inverterId = this.entity.id;
      } else {
        data.projectId = this.entity.id;
      }
      if (this.timeType == "UNLIMITED") {
        data.startTime = new Date("2021-01-01 00:00:00").getTime();
        data.endTime = new Date().getTime();
      } else {
        data.startTime = this.$moment(new Date(this.timeValue))
          .startOf(
            this.timeType == "MONTH"
              ? "months"
              : this.timeType == "YEAR"
              ? "year"
              : ""
          )
          .format("x");
        data.endTime = this.$moment(new Date(this.timeValue))
          .endOf(
            this.timeType == "DAY"
              ? "day"
              : this.timeType == "MONTH"
              ? "months"
              : this.timeType == "YEAR"
              ? "year"
              : ""
          )
          .format("x");
      }
      this.activeTimeValue = this.timeValue;
      this.chartsData.xData = [];
      this.chartsData.yData = [];
      let res = await api.photovoltaicFindGenAndPeriodEC(data);
      if (res?.data.code == 200) {
        let tsValue = res.data.data["tsValue"];
        let keyArr = [];
        for (let key in tsValue) {
          keyArr.push(parseInt(key));
        }
        keyArr.sort((a, b) => {
          return a - b;
        });
        let xData = [];
        let yData = [];
        keyArr.map((value) => {
          let timestamp = this.$moment(value).format(this.format);
          xData.push(timestamp);
          yData.push(tsValue[value]["EC_Hour"].toFixed(2));
        });
        this.chartsData.xData = xData;
        this.chartsData.yData = yData;
      }
    },
    exportExcel() {
      let th = ["时间", "发电量(kw·h)"];
      // 内容区
      let content = [];
      for (let i = 0; i < this.chartsData.xData.length; i++) {
        let row = [];
        row.push(this.chartsData.yData[i]);
        row.unshift(this.chartsData.xData[i]);
        content.push(row);
      }
      exportFile.xlsxFile(
        XLSX,
        `${this.entity.type == "project" ? "全部电站" : this.entity.name}-${
          this.activeTimeValue ? this.activeTimeValue : "全部"
        }发电量`,
        {
          excel: [th, ...content],
        }
      );
    },
  },
  watch: {
    entity: {
      handler(newVal, oldVal) {
        if (this.isCreated) {
          this.timeType = "DAY";
          this.getDataValue();
          this.isCreated = false;
        }
        this.submit();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.PhotovoltaicStationCharts {
  width: 100%;
  height: 660px;
  .timeHead {
    width: 100%;
    height: 60px;
    // background-color: salmon;
    @include setFlexStart;
  }
  .chartsWrap {
    width: 100%;
    height: calc(100% - 80px);
    margin-top: 10px;
    // background-color: sandybrown;
  }
}
</style>
